import layout from '../layout'
export default function makeEbookRoutes({
  contentType,
  components: { EbookListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/`,
          component: EbookListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
